import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouteObject, RouterProvider } from "react-router-dom";
import { Administration } from "./admin/Administration";
import { TablesEditor } from "./tables/TablesEditor";
import { EventReservationsById, EventReservationsByTag } from "./reservation/EventReservations";
import { LocaleContextProvider } from "./commons/translations/LocaleContext";
import { TableReservationByTag } from "./tables/TableReservationByTag";
import { HomePage } from "./launcher/home/HomePage";
import { OauthLoginPage } from "./launcher/auth/OauthLoginPage";
import { AuthStateContextProvider } from "./launcher/auth/LauncherAuthContext";
import { SingUpPage } from "./launcher/auth/SingUpPage";
import { ProfilePage } from "./launcher/auth/ProfilePage";
import { TermsAndConditions } from "./admin/terms/TermsAndConditions";
import { PrivacyPolicy } from "./admin/terms/PrivacyPolicy";
import { MyReservations } from "./launcher/my/MyReservations";
import { ReservationOverview } from "./launcher/my/ReservationOverview";
import { Contact } from "./launcher/contact/Contact";
import { OrganizerHome } from "./launcher/organizer/OrganizerHome";
import { OrganizerAdventures } from "./launcher/organizer/OrganizerAdventures";
import { BrowseInvitationsPage } from "./launcher/invitations/BrowseInvitationsPage";
import { InvitationDetailPage } from "./launcher/invitations/InvitationDetailPage";
import { JoinRequestDetailPage } from "./launcher/joinrequests/JoinRequestDetailPage";
import { OrganizerJoinRequestsPage } from "./launcher/organizer/OrganizerJoinRequestsPage";
import { OrganizerInvitationsPage } from "./launcher/organizer/OrganizerInvitationsPage";
import { SessionsPage } from "./launcher/sessions/SessionsPage";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient();

const reservationRoutes: RouteObject[] = [{
    path: "/events/:eventId",
    element: <EventReservationsById />,
}, {
    path: "/reserve/:eventTag",
    element: <EventReservationsByTag />,
}, {
    path: "/reserve/:eventTag/:tableTag",
    element: <TableReservationByTag />,
}, {
    path: "/admin",
    element: <Administration />
}, {
    path: "/admin/tables/:event",
    element: <TablesEditor />
}];

const router = createBrowserRouter([
    {
        path: "/",
        element: <HomePage />,
        hasErrorBoundary: true,
        errorElement: (<div>404</div>),
        index: true
    }, {
        path: "/invitations",
        element: <BrowseInvitationsPage />
    }, {
        path: "/invitations/:id",
        element: <InvitationDetailPage />
    }, {
        path: "/join-requests/:id",
        element: <JoinRequestDetailPage />
    }, {
        path: "/contact",
        element: <Contact />
    }, {
        path: "/login",
        element: <OauthLoginPage />
    }, {
        path: "/signup",
        element: <SingUpPage />
    }, {
        path: "/profile",
        element: <ProfilePage />
    }, {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />
    }, {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
    }, {
        path: "/my-reservations",
        element: <MyReservations />
    }, {
        path: "/my-reservations/:reservationId",
        element: <ReservationOverview />
    }, {
        path: "/sessions",
        element: <SessionsPage />
    }, {
        path: "/organizer",
        element: <OrganizerHome />
    }, {
        path: "/organizer/adventures",
        element: <OrganizerAdventures />
    }, {
        path: "/organizer/adventures/:adventureId/join-requests",
        element: <OrganizerJoinRequestsPage />
    }, {
        path: "/organizer/invitations",
        element: <OrganizerInvitationsPage />
    }, {
        path: "/organizer/invitations/:invitationId/join-requests",
        element: <OrganizerJoinRequestsPage />
    },
    ...reservationRoutes
]);

root.render(
    <>
        <div id="hidden-div-element-re-captcha" style={{ visibility: 'hidden', zIndex: -5000, height: 0 }} />
        <LocaleContextProvider>
            <QueryClientProvider client={queryClient}>
                <AuthStateContextProvider>
                    <RouterProvider router={router} />
                </AuthStateContextProvider>
            </QueryClientProvider>
        </LocaleContextProvider>
    </>
);
